// @flow
import localforage from 'localforage';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { hideSourcesLoader, showSourcesLoader, updateSourcesLoader } from './actions';
import {
  START_HIDE_SOURCES_LOADER_TIMER,
  TRIGGER_SOURCES_LOADER,
  UPDATE_SOURCES_LOADER,
} from './actionTypes';
import { LOADER_DELAY_TIME, LOCALFORAGE_KEYS } from '../constants';
import { getLastSearch } from '~/common/selectors/config';

export function* updateLoader(action: TrovitAction): Generator<*, *, *> {
  return yield call(
    [localforage, localforage.setItem],
    LOCALFORAGE_KEYS.lastUrlWithSourcesLoader,
    action.payload.lastSearchUrl
  );
}

export function* triggerLoader(): Generator<*, *, *> {
  const lastUrlWithSourcesLoader = yield call(
    [localforage, localforage.getItem],
    LOCALFORAGE_KEYS.lastUrlWithSourcesLoader
  );
  const currentUrl = yield select(getLastSearch);

  if (!lastUrlWithSourcesLoader || lastUrlWithSourcesLoader !== currentUrl) {
    return yield put(showSourcesLoader());
  }

  return false;
}

export function* delayHideLoader(): Generator<*, *, *> {
  yield call(delay, LOADER_DELAY_TIME);
  yield put(hideSourcesLoader());

  // Store the last url we've seen the sources loader
  const lastSearchUrl = yield select(getLastSearch);
  yield put(updateSourcesLoader({ lastSearchUrl }));
}

export default function* loaderSagas(): Generator<*, *, *> {
  yield takeLatest(UPDATE_SOURCES_LOADER, updateLoader);
  yield takeLatest(TRIGGER_SOURCES_LOADER, triggerLoader);
  yield takeLatest(START_HIDE_SOURCES_LOADER_TIMER, delayHideLoader);
}



// WEBPACK FOOTER //
// ./app/Sources/loader/sagas.js